/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_iteratorToArray.js
 ** module id = 772
 ** module chunks = 0
 **/